/**
 * Join conditional class names into a single string.
 *
 * A deliberately tiny, dependency-free helper. Falsy values are dropped so
 * conditional classes can be expressed inline:
 *
 *   cn("btn", isActive && "btn--active", disabled ? "opacity-50" : null)
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  let out = "";
  for (const value of values) {
    if (!value) continue;
    out += (out ? " " : "") + value;
  }
  return out;
}
